<template>
  <VueFinalModal
    v-model="show"
    classes="tw-flex tw-items-center tw-justify-center"
    content-class="feedback-modal-content"
  >
    <div
      class="tw-bg-white tw-rounded-xl tw-shadow-lg tw-w-[95vw] md:tw-w-[85vw] tw-h-[88vh] md:tw-h-[80vh] tw-flex tw-flex-col tw-overflow-hidden"
    >
      <!-- Header -->
      <div
        class="tw-flex tw-justify-between tw-items-center tw-px-5 tw-py-3 tw-border-b tw-border-slate-200 tw-shrink-0"
      >
        <h2 class="tw-font-bold tw-text-lg">💬 Centro Assistenza</h2>
        <button
          class="tw-text-slate-400 hover:tw-text-slate-600 tw-text-2xl tw-leading-none"
          aria-label="Chiudi"
          @click="close"
        >
          ×
        </button>
      </div>

      <!-- Corpo -->
      <div
        class="tw-flex-1 tw-min-h-0 tw-min-w-0 tw-flex tw-flex-col md:tw-flex-row"
      >
        <!-- Colonna lista -->
        <div
          class="tw-min-h-0 tw-p-4 md:tw-w-[360px] md:tw-shrink-0 md:tw-border-r md:tw-border-slate-200 md:tw-flex md:tw-flex-col"
          :class="
            view === 'list' ? 'tw-flex tw-flex-col tw-flex-1' : 'tw-hidden'
          "
        >
          <FeedbackTicketList
            :items="myFeedback"
            :selected-id="selectedId"
            @select="selectTicket"
            @new="openNew"
          />
        </div>

        <!-- Colonna destra -->
        <div
          class="tw-min-h-0 tw-p-4 md:tw-flex-1 md:tw-min-w-0 md:tw-flex md:tw-flex-col"
          :class="
            view !== 'list' ? 'tw-flex tw-flex-col tw-flex-1' : 'tw-hidden'
          "
        >
          <FeedbackNewTicketForm
            v-if="view === 'new'"
            :page-url="pageUrl"
            @submitted="onFormSubmitted"
            @cancel="backToList"
          />
          <div
            v-else-if="loadingDetail"
            class="tw-flex tw-items-center tw-justify-center tw-h-full tw-text-sm tw-text-slate-400"
          >
            Caricamento…
          </div>
          <FeedbackTicketDetail
            v-else
            :ticket="currentTicket"
            :sending="sending"
            @back="backToList"
            @new="openNew"
            @send="onSend"
          />
        </div>
      </div>
    </div>
  </VueFinalModal>
</template>

<script>
import feedbackService from "../services/feedbackService";
import FeedbackTicketList from "./FeedbackTicketList.vue";
import FeedbackTicketDetail from "./FeedbackTicketDetail.vue";
import FeedbackNewTicketForm from "./FeedbackNewTicketForm.vue";

export default {
  name: "FeedbackModal",
  components: {
    FeedbackTicketList,
    FeedbackTicketDetail,
    FeedbackNewTicketForm,
  },
  inject: ["feedbackConfig"],
  props: {
    modelValue: { type: Boolean, default: false },
    myFeedback: { type: Array, default: () => [] },
    pageUrl: { type: String, default: "" },
  },
  emits: ["update:modelValue", "submitted", "refresh"],
  data() {
    return {
      view: "list", // 'list' | 'detail' | 'new'
      selectedId: null,
      currentTicket: null,
      loadingDetail: false,
      sending: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.view = "list";
        this.selectedId = null;
        this.currentTicket = null;
      }
    },
    // Sync leggero del dettaglio aperto se arriva un nuovo messaggio (dal polling lista).
    myFeedback(list) {
      if (this.view !== "detail" || !this.selectedId || !this.currentTicket)
        return;
      const summary = list.find((t) => t.id === this.selectedId);
      if (
        summary &&
        summary.lastMessageAt !== this.currentTicket.lastMessageAt
      ) {
        this.loadDetail(this.selectedId, true);
      }
    },
  },
  methods: {
    close() {
      this.show = false;
    },
    async loadDetail(id, silent = false) {
      if (!silent) this.loadingDetail = true;
      try {
        const { data } = await feedbackService.getTicket(id);
        this.currentTicket = data.ticket;
        // il server ha marcato visto → aggiorna badge/lista
        this.$emit("refresh");
      } catch (err) {
        this.feedbackConfig?.notify?.(
          err?.response?.data?.message || "Errore nel caricamento del ticket.",
          { type: "error" }
        );
      } finally {
        this.loadingDetail = false;
      }
    },
    selectTicket(id) {
      this.selectedId = id;
      this.view = "detail";
      this.currentTicket = null;
      this.loadDetail(id);
    },
    openNew() {
      this.view = "new";
    },
    backToList() {
      this.view = "list";
    },
    async onSend({ body, files, resetDraft }) {
      if (!this.selectedId) return;
      this.sending = true;
      try {
        const { data } = await feedbackService.addMessage(this.selectedId, {
          body,
          files,
        });
        this.currentTicket = data.ticket;
        resetDraft?.(); // pulisce il box SOLO dopo successo
        this.$emit("refresh");
      } catch (err) {
        this.feedbackConfig?.notify?.(
          err?.response?.data?.message || "Invio non riuscito. Riprova.",
          { type: "error" }
        );
      } finally {
        this.sending = false;
      }
    },
    onFormSubmitted(newId) {
      this.$emit("submitted");
      this.$emit("refresh");
      if (newId) {
        this.selectedId = newId;
        this.view = "detail";
        this.currentTicket = null;
        this.loadDetail(newId);
      } else {
        this.view = "list";
      }
    },
  },
};
</script>
